<div class="grid-12">
  <div class="span-12-6">
    <div class="color__wrapper" [ngStyle]="{ 'background-color': colorCode }"></div>
    <span class="color__info">19-1757 - <strong>Red</strong></span>
  </div>
  <div class="span-12-6">
    <div class="form-box-row">
      <label for="">Brand</label>
      <strong>Target</strong>
    </div>
    <div class="form-box-row">
      <label for="">Customer</label>
      <strong>Zane</strong>
    </div>
  </div>
</div>
